export default [
  {
    title: '推荐阅读',
    name: 'article',
  },
  {
    title: '服务协议',
    name: 'serve',
  }
];



// WEBPACK FOOTER //
// ./src/route/miniProgramRoute.js